module.exports = __webpack_public_path__ + "static/media/cv.f282fb3b.pdf";